import React, { useState, useEffect } from 'react';

const Visionn = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const sectionStyle = {
        padding: isMobile ? '0px' : '40px',
        margin: '0 auto',
    };

    const containerStyle = {
        maxWidth: isMobile ? '100%' : '1200px',
        margin: '0 auto',
        padding: '0 15px',
    };

    const rowStyle = {
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'center',
        gap: '20px',
    };

    const colStyle = {
        flex: '1',
        minWidth: isMobile ? '100%' : '300px',
        boxSizing: 'border-box',
        marginBottom: isMobile ? '20px' : '0',
    };

    const headingStyle = {
        textAlign: 'center',
        paddingBottom: '20px',
        fontSize: isMobile ? '24px' : '32px',
        color: '#343a40',
    };

    const visionContentStyle = {
        backgroundColor: '#FF4101', 
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
        color: 'white',
    };

    const sectionTitleStyle = {
        color: '#FF4101', // Light color for titles
    };
    const sectionTitleStylee = {
        color: 'white'
    };

    return (
        <section style={sectionStyle}>
            <div style={containerStyle}>
                <h3 style={{ ...headingStyle, ...sectionTitleStyle }}>About Our Vision & Mission</h3>
                <div style={rowStyle}>
                    <div style={colStyle}>
                        <div style={visionContentStyle}>
                            <h4 style={sectionTitleStylee}>Vision</h4>
                            <p className='text-white'>
                            At AB Ghule Cabs, our vision is to redefine the travel experience by providing exceptional, dependable, and comfortable transportation services that cater to the unique needs of every traveler. We are dedicated to offering a seamless journey, whether you're traveling for business, leisure, or a special occasion. Our commitment to customer satisfaction, safety, and punctuality ensures that each trip with us is stress-free and enjoyable.

We embrace the latest technology to enhance the travel experience, offering easy booking options and real-time tracking for your convenience. Additionally, we prioritize sustainability by implementing eco-friendly practices to reduce our carbon footprint. At AB Ghule Cabs, we believe that every journey should be as smooth and pleasant as possible.
                            </p>
                        </div>
                    </div>
                    <div style={colStyle}>
                        <div style={visionContentStyle}>
                            <h4 style={sectionTitleStylee}>Mission</h4>
                            <p className='text-white'>
                            At AB Ghule Cabs, our mission is to offer exceptional customer service by delivering reliable, timely, and comfortable transportation solutions. We are committed to providing a seamless and enjoyable travel experience by ensuring the highest standards of safety, with well-trained drivers and meticulously maintained vehicles. Listening to our customers and continuously improving our services is at the core of our approach, allowing us to consistently exceed expectations.

We aim to build long-lasting relationships with our passengers, ensuring that every ride with AB Ghule Cabs is not only convenient but also a positive and memorable experience. Our dedication to punctuality, safety, and customer satisfaction makes us the preferred choice for all your travel needs.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Visionn;
